module.exports = "/_next/static/images/mushroom-ccf01be53492c36996cf5bd66e5b8c07.png";